import React, { useEffect, useRef, useState } from 'react';

const Footer = ({isFullScreen = false}) => {
    const timeRef = useRef(new Date()); // useRef para mantener la referencia de la hora sin provocar re-render
    const [, forceRender] = useState(0); // Pequeño hack para forzar la actualización visual

    useEffect(() => {
        const interval = setInterval(() => {
            timeRef.current = new Date(); // Actualiza la referencia
            forceRender(prev => prev + 1); // Fuerza la actualización sin usar useState para guardar la fecha
        }, 1000);

        return () => clearInterval(interval); // Limpieza del intervalo al desmontar
    }, []);

    const formattedDate = timeRef.current.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    return (
        <footer className={isFullScreen ? 'fullScreen' : ''}>
            <span style={{fontSize: '0.7rem'}}>&copy; LeptónCheck - 2026 v1.9.0</span>
            <span style={{fontSize: '0.7rem'}}>{timeRef.current.toLocaleTimeString()} - {formattedDate}</span>
        </footer>
    );
};

export default Footer;
